import {remote} from '../constants/environment';
import {IDocumentListResponse} from '../interfaces/services/document-list.interface';
import {IDocumentDto} from '../interfaces/dtos';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getDocumentList = async (
  token: string,
): Promise<IDocumentListResponse> => {
  const remoteURI = remote.getDocumentListUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as IDocumentDto[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IDocumentListResponse;
};
